import { ChevronsUpDown, CircleUser, EyeOff, LogOut } from "lucide-react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { router, usePage } from "@inertiajs/react";

export function NavUser() {
  const { isMobile } = useSidebar();
  const { impersonation } = usePage().props;
  const user = usePage().props.user!;
  const isImpersonating = impersonation?.active;

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <Avatar className="h-8 w-8 rounded-lg">
                <AvatarImage src={user.avatar} alt={user.name} />
                <AvatarFallback className="rounded-lg">
                  <CircleUser />
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className={cn("truncate font-medium", isImpersonating && "text-amber-600 dark:text-amber-400")}>{user.name}</span>
                <span className={cn("truncate text-xs", isImpersonating && "text-amber-600/70 dark:text-amber-400/70")}>{user.email}</span>
              </div>
              <ChevronsUpDown className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <Avatar className="h-8 w-8 rounded-lg">
                  <AvatarImage src={user.avatar} alt={user.name} />
                  <AvatarFallback className="rounded-lg">
                    <CircleUser />
                  </AvatarFallback>
                </Avatar>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className={cn("truncate font-medium", isImpersonating && "text-amber-600 dark:text-amber-400")}>{user.name}</span>
                  <span className={cn("truncate text-xs", isImpersonating && "text-amber-600/70 dark:text-amber-400/70")}>{user.email}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            {isImpersonating && (
              <>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  onClick={() => router.delete("/app/impersonation")}
                >
                  <EyeOff />
                  Parar de Personificar
                </DropdownMenuItem>
              </>
            )}
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => router.delete("/session")}>
              <LogOut />
              Sair
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
